/**
 * 常停地点
 */
import { FREQUENTLOCATIONS } from '../types';

export default {
    name: `${FREQUENTLOCATIONS}`,
    path: '/frequentLocations',
    component: () => import(/* webpackChunkName: 'frequentLocations' */ '@/views/frequentLocations/'),
    redirect: { name: `${FREQUENTLOCATIONS}Index` },
    meta: {
        title: '常停地点',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${FREQUENTLOCATIONS}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'frequentLocations' */ '@/views/frequentLocations/home/Home.vue'),
        },

        // 二级页面示例, 没有二级页面就直接删掉
        {
            name: `${FREQUENTLOCATIONS}Detail`,
            path: 'detail/:longitude/:latitude/:recentDays/:address',
            component: () => import(/* webpackChunkName: 'frequentLocations' */ '@/views/frequentLocations/detail/Detail.vue'),
        },
    ],
};
